import SideControlsPage from "Layouts/SideControls/SideControlsPage";
import { MAIN_APP_BAR_HEIGHT_PX } from "components/Navigation/appBarHeight";
import { observer } from "mobx-react";
import React from "react";
import { useStore } from "utils/useStore";
import ConversationRouting from "./Views/Main/ConversationRouting";
import ConversationsStore from "./Stores/ConversationsStore";
import ConversationDrawer from "./Views/Drawer/ConversationDrawer";
import { useTheme } from "@mui/material";

const Conversations: React.FunctionComponent = observer(() => {
    const store = useStore(ConversationsStore);

    React.useEffect(() => {
        return () => {
            store.cancelConversationsRequests();
        };
    }, [store]);
    const theme = useTheme();
    return (
        <SideControlsPage
            drawerMinWidth={!store.isFocused ? 400 : 248}
            drawerContent={<ConversationDrawer />}
            mainContent={<ConversationRouting />}
            drawerLocation="left"
            mainGridSpacing={0}
            mainGridJustify={"flex-start"}
            mainGridAlignItems={"stretch"}
            containerOffsetPixels={MAIN_APP_BAR_HEIGHT_PX}
            drawerVerticalOffsetPixels={0}
            drawerMaxWidth={400}
            mainSx={{
                paddingTop: theme.spacing(5),
                paddingLeft: theme.spacing(5),
                paddingRight: theme.spacing(5),
            }}
            addMargin={"0.5rem"}
        />
    );
});

export default Conversations;
